export default __webpack_public_path__ + "static/media/RotateRight.bb75c327.svg";